import { render, staticRenderFns } from "./CarouselEntrada.vue?vue&type=template&id=35cf1be3&scoped=true&"
import script from "./CarouselEntrada.vue?vue&type=script&lang=js&"
export * from "./CarouselEntrada.vue?vue&type=script&lang=js&"
import style0 from "./CarouselEntrada.vue?vue&type=style&index=0&id=35cf1be3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cf1be3",
  null
  
)

export default component.exports